import LoginProfileView from './LoginProfileView';

export default LoginProfileView;